// extracted by mini-css-extract-plugin
module.exports = {"acf-inspiration-blocks":"acf-inspiration-blocks_acf-inspiration-blocks__00y6u"};